




















import {useActions, useGetters} from "vuex-composition-helpers"
import {ActionTree, GetterTree} from "vuex"
import {defineComponent} from "@vue/composition-api"
import {MyStudyChoiceOnboardingModelState} from "@/apps/MyStudyChoiceOnboardingWidget/models/store-viewmodel"
import ButtonComponent from "@/shared/components/Button.vue"

export default defineComponent({
    name: "FooterNavigation",
    components: {
        ButtonComponent,
    },
    setup: () => {
        const {
            setNextStep, setPreviousStep, setCompleteOnboarding
        } = useActions<ActionTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'setNextStep', 'setPreviousStep', 'setCompleteOnboarding'
        ])
        const {
            getLabels, getIsLastStep, getCanContinue, getActiveStepIndex
        } = useGetters<GetterTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'getLabels', 'getIsLastStep', 'getCanContinue', 'getActiveStepIndex'
        ])

        return {
            getLabels,
            getCanContinue,
            setNextStep,
            setPreviousStep,
            getIsLastStep,
            getActiveStepIndex,
            setCompleteOnboarding
        }
    }
})
